import {DefaultTheme} from 'styled-components';
import {mix, rgba} from 'polished';

import {black, chambray, cod, ice, malibu, white, sapphire, night, gray, electricity, purple, aliceBlue} from '../colors';

export const Theme: DefaultTheme = {
    button: {
        backgroundColor: sapphire,
        color: white
    },
    svg: {
        authors: {
            backgroundColor: ice,
            foregroundColor: rgba(chambray, 0.2)
        }
    },
    profile: {
        background: `linear-gradient(180deg, ${sapphire} 0%, ${night} 100%)`,
        stroke: {
            icon: rgba(ice, 0.25),
            separator: rgba(ice, 0.08)
        },
        widget: {
            headline: {
                light: white,
                dark: sapphire
            }
        },
        commentHistory: {
            separator: sapphire,
            divider: ice,
            imageFallback: ice,
            showAll: sapphire,
            headerBottom: aliceBlue,
            note: gray,
            skeleton: sapphire
        }
    },
    color: {
        primary: chambray,
        secondary: malibu,
        foreground: black,
        breadcrumb: mix(0.265, chambray, ice),
        background: white,
        label: mix(0.4, cod, white),
        publishDate: mix(0.4, cod, white),
        primaryIcon: cod,
        secondaryIcon: electricity,
        tertiaryIcon: purple
    },
    font: {
        family: {
            primary: '"Baton Turbo", sans-serif',
            secondary: '"Baton Turbo Book", sans-serif'
        },
        weight: {
            normal: 400,
            bold: 600,
            heavy: 900
        },
        color: {
            content: cod,
            secondary: gray
        }
    },
    breakpoint: {
        tablet: '576px',
        desktop: '1144px'
    }
};
